import { IS_DEV } from "@/features/config";
import { useFeatureFlags } from "@/features/config/useFeatureFlags";
import { datasetsAccess, oldDatasetHref } from "./routes";

export const useDatasetsAccess = () => {
  const { flags } = useFeatureFlags();
  return datasetsAccess(flags, IS_DEV);
};

/** Links to old (curator) datasets: /datasets, or /datasets/legacy where the new Datasets replace them. */
export const useOldDatasetHref = () => {
  const access = useDatasetsAccess();
  return (datasetId: string) => oldDatasetHref(access, datasetId);
};
